import axios from "axios";
import { getUserToken, setUserToken } from "@/api/createTokenProvider";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Add API KEY to query params for every request
    const apiKey = import.meta.env.VITE_API_KEY_CARBU;
    if (apiKey) {
       config.params = config.params || {};
       config.params['api_key'] = apiKey;
    }

    const token = getUserToken()?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      //place your reentry code
      console.log("error 401");
      setUserToken(null);
      // useNavigate("/");

      //return Promise.reject(error);
    }
    console.log(error.response.data);
    return Promise.reject(error);
  }
);

export default instance;
